import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Box, Modal, Snackbar, makeStyles } from '@material-ui/core';
import { useMediaQuery } from '@mui/material';
import TripTimelineContent from './TripTimelineContent';
import { api_call, getLocalTimezone } from '../helpers/untils';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '640px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  maxHeight: '100vh',
  overflowY: 'auto'
};
const useStyles = makeStyles(() => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  formContainer: {
    display: 'block',
    width: '100%',
  }

}));

const TripTimelineModal = (props) => {
  const { open, setOpen, deviceId } = props;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session.user);
  const theme = useTheme();
  const xsDown = useMediaQuery(theme.breakpoints.down('sm'));

  const [apiLoading, setApiLoading] = useState(false)
  const defaultPageData = {
    device: {},
    timelineList: []
  }
  const [pageData, setPageData] = useState(defaultPageData)

  const handleModalClose = () => {
    setOpen("")
  }

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const showToast = (msg) => {
    setSnackbarOpen(true)
    setToastMessage(msg)
  }

  useEffect(() => {
    if (open) {
      setPageData(defaultPageData);
      loadTripTimelineData();
    }
  }, [open])

  const loadTripTimelineData = async () => {
    const iana_timezone = getLocalTimezone();
    const url = `/api/device-timeline/get-page-data?deviceId=${deviceId}&iana_timezone=${iana_timezone}`;
    setApiLoading(true);
    const response = await api_call(url);
    if (response.ok) {
      const data = await response.json();
      setPageData(data);
      setApiLoading(false);
    }
  }

  //////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={1500}
            message={toastMessage}
          />
          {/* <Stack direction={`row`} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography id="modal-modal-title" variant="h6" component="h2">{`Trip Timeline`}</Typography>
              </Stack> */}
          <Box>
            <TripTimelineContent
              pageData={pageData}
              apiLoading={apiLoading}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default TripTimelineModal;
